export default __webpack_public_path__ + "static/media/cover2.79ae69ca.jpg";